import React, { useEffect, useRef } from "react";

interface VerticalAnchorItemProps {
  children: React.ReactNode;
  "data-key": string;
  scrollToView?: boolean;
  className?: string;
}

const VerticalAnchorItem = ({
  children,
  "data-key": dataKey,
  scrollToView,
  className = "",
}: VerticalAnchorItemProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // 如果设置了scrollToView，则滚动到该Card
    if (scrollToView && containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [scrollToView]);

  return (
    <div ref={containerRef} data-key={dataKey} className={className}>
      {children}
    </div>
  );
};

export default VerticalAnchorItem;
